module.exports = __webpack_public_path__ + "static/media/logo-symbol.b0ea8a65.svg";